<div class="card card-nc esign_box ">
  <div class="container">
    <div class="col-12">
      <div style="width: 80%; margin: 0 auto;">
        <app-progress-bar
          [whichStep]="1"
          [sectionsArray]="tabs"
        ></app-progress-bar>
      </div>
    </div>
  </div>
  <br />
  <div class="enrollHeading">
    Please Review & Confirm
  </div>
  <div class="enrollHelpTitle">
    Both sections must be reviewed and checked before you can proceed
  </div>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-nc subEnroll">
          <div class="card-body enroll">
            <div class="enrollHelpTitle">
              <br />
              <app-e-sign-pdf></app-e-sign-pdf>
              <br />
              <a href="../assets/e_sign_nc.pdf" target="_blank" download
                >Download</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="card card-nc subEnroll">
          <div class="card-body enroll">
            <div class="enrollHelpTitle">
              <br />
              <div class="checkbox">
                <label>
                  <input type="checkbox" [(ngModel)]="agree" value="true" />
                  I agree to receive all disclosures and receipts
                  electronically. I certify I have read, met and agree to all
                  terms, conditions, and disclosures outlined here.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button
          id="enroll_button"
          type="button"
          class="btn btn-block pull-right"
          (click)="next()"
          [disabled]="!agree"
        >
          Next
        </button>
      </div>
    </div>
  </div>
</div>
